export const showFeature = (switches, name, role, userId) => {
  if (!switches || switches.length === 0) {
    return false;
  }
  const featureSwitch = switches.find((f) => f.name === name);

  if (featureSwitch && featureSwitch.all_roles) {
    return true;
  }

  if (role && role.length > 0) {
    if (featureSwitch?.allowed_roles && featureSwitch?.allowed_roles.length > 0) {
      if (featureSwitch?.allowed_roles.toLowerCase().includes(role.toLowerCase())) {
        return true;
      }
    }
  }

  if (userId && userId > 0) {
    if (featureSwitch?.allowed_users && featureSwitch?.allowed_users.length > 0) {
      // Modified to account for comma-separated and comma + space-separated.
      const userList = featureSwitch?.allowed_users
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item);
      if (userList.includes(userId.toString())) {
        return true;
      }
    }
  }

  return false;
};
